import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-energy-map-overlay',
  templateUrl: './energy.map.overlay.component.html'
})
export class EnergyMapOverlayComponent {
  /**
   * The form group with all controls
   * @protected
   */
  form: UntypedFormGroup;

  /**
   * The next step were we should navigate with the next button to.
   */
  nextStep: string = null;

  /**
   * constructor
   * @param data
   * @param dialogRef
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: {textkeyPrefix: string, lastStep: string, nextStep: string, anfrage: any},
              private dialogRef: MatDialogRef<EnergyMapOverlayComponent>) {
    this.form = new UntypedFormGroup({
        energy_map_confirm_donation : new UntypedFormControl(this.data.anfrage.verbrauchsanalyseInput.energy_map_confirm_donation,
            [Validators.required])
    });
  }

  /**
   * submit the form.
   */
  submitForm(): void {
    if (this.form.valid) {
      const newData = this.form.getRawValue();
      this.dialogRef.close({data: newData});
    }
  }
}
